import { createReducer } from 'typesafe-actions';

import { RolesActionValues, TRolesActions } from '../../features/roles/store/types/roles.types';

import { TAuthAction, AuthActionTypes, IAuthState } from '@/store/types/auth.types';
import { SupportUserActionTypes } from '@/features/dashboard-users/store/types/support-user.types';
import { auth2FaReducer } from '@/features/2fa/store/reducers/auth2Fa.reducer';

const initialState: IAuthState = {
  isLoading: false,
};

const baseAuthReducer = createReducer<IAuthState, TAuthAction | TRolesActions>(initialState)
  .handleType(AuthActionTypes.FETCH_ACCESS_TOKEN, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(AuthActionTypes.FETCH_ACCESS_TOKEN_SUCCESS, (state, action) => ({
    ...state,
    token: action.token,
    currentSupportUser: { ...state.currentSupportUser, state: action.currentSupportUser },
    isLoading: false,
  }))

  .handleType(AuthActionTypes.FETCH_ACCESS_TOKEN_FAIL, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  }))

  .handleType(AuthActionTypes.REFRESH_TOKEN, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(AuthActionTypes.REFRESH_TOKEN_SUCCESS, (state, action) => {
    return {
      ...state,
      token: action.accessToken,
      isLoading: false,
      error: undefined,
    };
  })

  .handleType(AuthActionTypes.REFRESH_TOKEN_FAIL, (state, action) => {
    return {
      ...state,
      error: action.error,
      isLoading: false,
    };
  })

  .handleType(SupportUserActionTypes.SET_CURRENT_SUPPORT_USER, (state, action) => {
    return {
      ...state,
      currentSupportUser: {
        ...state.currentSupportUser,
        state: { ...action.user },
      },
    };
  })

  .handleType(SupportUserActionTypes.UPDATE_CURRENT_SUPPORT_USER_METADATA, (state, action) => {
    return {
      ...state,
      currentSupportUser: {
        ...state.currentSupportUser,
        state: {
          ...state.currentSupportUser.state,
          metadata: {
            ...state.currentSupportUser.state.metadata,
            edit: {
              isLoading: true,
              error: undefined,
              state: {
                id: action.favoriteId,
              },
            },
          },
        },
      },
    };
  })

  .handleType(SupportUserActionTypes.UPDATE_CURRENT_SUPPORT_USER_METADATA_FAIL, (state, action) => {
    return {
      ...state,
      currentSupportUser: {
        ...state.currentSupportUser,
        state: {
          ...state.currentSupportUser.state,
          metadata: {
            ...state.currentSupportUser.state.metadata,
            edit: {
              isLoading: false,
              error: action.error,
            },
          },
        },
      },
    };
  })

  .handleType(SupportUserActionTypes.UPDATE_CURRENT_SUPPORT_USER_METADATA_SUCCESS, (state, action) => {
    return {
      ...state,
      currentSupportUser: {
        ...state.currentSupportUser,
        state: {
          ...state.currentSupportUser.state,
          metadata: {
            ...state.currentSupportUser.state.metadata,
            favorites: action.favorites,
            edit: {
              isLoading: false,
              error: undefined,
            },
          },
        },
      },
    };
  })

  .handleType(RolesActionValues.SET_ROLE_SUCCESS, (state, action) => {
    return {
      ...state,
      currentSupportUser: {
        ...state.currentSupportUser,
        state: {
          ...state.currentSupportUser.state,
          metadata: {
            ...state.currentSupportUser.state.metadata,
            role: action.role,
          },
        },
      },
    };
  })
  .handleType(RolesActionValues.SET_ROLE_FAILED, (state) => {
    return {
      ...state,
      currentSupportUser: {
        ...state.currentSupportUser,
        state: {
          ...state.currentSupportUser.state,
          metadata: {
            ...state.currentSupportUser.state.metadata,
            role: undefined,
          },
        },
      },
    };
  })
  .handleType(SupportUserActionTypes.SHOULD_CHANGE_PASSWORD, (state, { shouldChangePassword }) => ({
    ...state,
    currentSupportUser: {
      ...state.currentSupportUser,
      shouldChangePassword,
    },
  }))

  .handleType(SupportUserActionTypes.CHANGE_PASSWORD, (state) => ({
    ...state,
    currentSupportUser: {
      ...state.currentSupportUser,
      isLoading: true,
    },
  }))

  .handleType(SupportUserActionTypes.CHANGE_PASSWORD_SUCCESS, (state, action) => {
    return {
      ...state,
      currentSupportUser: {
        ...state.currentSupportUser,
        state: action.supportUser,
        isLoading: false,
      },
    };
  })

  .handleType(SupportUserActionTypes.CHANGE_PASSWORD_FAIL, (state, action) => {
    return {
      ...state,
      currentSupportUser: {
        ...state.currentSupportUser,
        isLoading: false,
        error: action.error,
      },
    };
  });

export const authReducer = createReducer<IAuthState, TAuthAction | TRolesActions>(initialState, {
  ...baseAuthReducer.handlers,
  ...auth2FaReducer.handlers,
});
